import { useQuery } from '@tanstack/react-query';
import { agentAPI } from '../api/agent.api';

export const useTriageHistory = (enabled: boolean) => {
  const { data, isLoading, error } = useQuery({
    queryKey: ['agent-triage-history'],
    queryFn: () => agentAPI.getTriageHistory({ limit: 20 }),
    enabled,
    staleTime: 30000,
    gcTime: 60000,
  });

  return {
    triageRuns: data?.data || [],
    isLoading,
    error,
  };
};
